const dragDropFile = {
  upload: {
    drag: 'השלך את הקובץ שלך כאן או',
    browse: 'עיין בקבצים שלך.',
  },

  uploaded: {
    success: 'הקובץ {{name}} הועלה בהצלחה',
    chooseAnotherFile: 'בחר קובץ אחר.',
  },
};

export default dragDropFile;
